import { useLang } from "@/lib/i18n";

const Logo = ({ light = false }) => {
  const { lang } = useLang();
  return (
    <span className="inline-flex items-center gap-3">
      <img
        src="/yannis-portrait.webp"
        alt="Ioannis Tsiros"
        className="h-14 w-14 rounded-full object-cover object-top ring-1 ring-sage-600/15"
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-xl tracking-tight ${
            light ? "text-background" : "text-sage-800"
          }`}
        >
          {lang === "el" ? "Ιωάννης Τσίρος" : "Ioannis Tsiros"}
        </span>
        <span
          className={`mt-1 text-[11px] tracking-[0.08em] ${
            light ? "text-background/60" : "text-muted-foreground"
          }`}
        >
          {lang === "el" ? "Msc Ψυχολόγος" : "MSc Psychotherapist"}
        </span>
      </span>
    </span>
  );
};

export default Logo;
